import { icons } from "../assets/icons/icons";
import { useSound } from "../components/SoundHandler";
import { ContainerShape, HexagonShape, InnerShape } from "../components/Shape";

export const ConfirmHardModeModal = ({ onConfirm: _onConfirm, onDismiss }: { onConfirm: () => void, onDismiss: () => void }) => {
  const sounds = useSound()

  const onClose = () => {
    onDismiss()
    sounds.play('click')
  };

  const onConfirm = () => {
    sounds.play('click')
    _onConfirm()
    onDismiss()
  }

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-[#18181B]/50">
      <div>
        <ContainerShape {...{cornerDiagonal: 20, cornerRadius: 8, strokeWidth: 2 }}>
          <div className="p-6 w-[350px] md:w-[448px]">
            <div className="flex flex-row justify-between">
              <div className="mt-1 text-2xl font-blinko font-black text-white">
                You are entering<br/>hard mode
              </div>

                <button className="" onClick={onClose}>
                <HexagonShape cornerRadius={6} strokeWidth={1}>
                  <div className="flex justify-center items-center p-2">
                    <img src={icons.close} className='w-6 h-6' />
                  </div>
                </HexagonShape>
              </button>
              
            </div>
            <div className="flex flex-col gap-2 mt-4 text-sm text-white">
              <ul className="space-y-1 list-none">
                <li>🎯 Regular hits = no payouts</li>
                <li>🔥 Bonus game = way higher rewards</li>
                <li>⚠️ More risk, higher volatility</li>
              </ul>
            </div>

            <div className="mt-6 flex justify-end space-x-2">
              <button onClick={onConfirm}>
                <InnerShape cornerDiagonal={14} cornerRadius={8} strokeWidth={1}>
                  <div className="relative px-6 py-3">
                    <p 
                      className="text-sm font-blinko text-white"
                    >
                      Enter
                    </p>
                  </div>
                </InnerShape>
              </button>
            </div>
          </div>
        </ContainerShape>
      </div>
    </div>
  );
}
